// Runtime backend URL resolution for cross-origin requests.
//
// The frontend can run from these hostnames:
//   webapp.local.*  — local dev (e.g., webapp.local.dev.bluereport.ch)
//   webapp.*        — deployed frontend (e.g., webapp.dev.bluereport.ch)
//   app.*           — same-origin legacy (no cross-origin needed)
//
// In the first two cases, API/auth calls must go to the backend at app.*.
// In the third case, relative paths work as-is (empty prefix).

function resolveOrigin(targetPrefix) {
    var hostname = window.location.hostname;
    // webapp.local.dev.bluereport.ch -> app.dev.bluereport.ch (strip webapp.local., add target prefix)
    if (hostname.indexOf('webapp.local.') === 0) {
        return 'https://' + targetPrefix + hostname.substring('webapp.local.'.length);
    }
    // webapp.dev.bluereport.ch -> app.dev.bluereport.ch
    if (hostname.indexOf('webapp.') === 0) {
        return 'https://' + hostname.replace('webapp.', targetPrefix);
    }
    return '';
}

export var backendOrigin = resolveOrigin('app.');

export function apiUrl(path) {
    return backendOrigin + path;
}

export function authUrl(path, options) {
    var url = backendOrigin + path;
    if (options && options.redirect) {
        var separator = path.indexOf('?') === -1 ? '?' : '&';
        url += separator + 'redirect=' + encodeURIComponent(options.redirect);
    }
    return url;
}

export function adminClipUrl(clipId) {
    var adminOrigin = resolveOrigin('admin.');
    if (adminOrigin) {
        return adminOrigin + '/clips/' + clipId;
    }
    return (window.location.protocol + '//' + window.location.hostname + '/clips/' + clipId)
        .replace('app.', 'admin.');
}

export function isCrossOrigin() {
    return backendOrigin !== '';
}
